(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-buy-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('suraiya-buy-now')) {
  customElements.define('suraiya-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      if (!this.form || !this.button) return;
      this.atc = this.form.querySelector('button[name="add"]');
      this.label = this.button.textContent;
      this.onClick = () => this.checkout();
      this.onChange = () => this.sync();
      this.button.addEventListener('click', this.onClick);
      this.form.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(() => this.sync());
      if (this.atc) this.observer.observe(this.atc, {attributes:true, attributeFilter:['disabled']});
      const variant = this.form.querySelector('[name="id"]');
      if (variant) this.observer.observe(variant, {attributes:true, attributeFilter:['disabled','value']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.form?.removeEventListener('change', this.onChange);
    }
    sync() {
      const variant = this.form.querySelector('[name="id"]');
      const disabled = !!(this.busy || !variant?.value || variant.disabled || this.atc?.disabled);
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
    }
    async checkout() {
      this.sync();
      if (this.button.disabled || !this.form.reportValidity()) return;
      const data = new FormData(this.form);
      if (!data.get('id')) return;
      this.busy = true;
      this.sync();
      this.button.setAttribute('aria-busy','true');
      this.button.textContent = this.dataset.processing;
      this.error.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST', body:data, headers:{Accept:'application/json'}, credentials:'same-origin', signal:controller.signal});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        this.error.textContent = error.name === 'AbortError' ? this.dataset.error : (error.message || this.dataset.error);
        this.error.hidden = false;
        this.busy = false;
        this.button.textContent = this.label;
        this.button.removeAttribute('aria-busy');
        this.sync();
      } finally {
        clearTimeout(timeout);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-extra-link"] && !Shopify.designMode) return;
  try {
    function initializeSuraiyaPanels(root) {
  const groups = [];
  if (root.matches?.('.suraiya-product-panels')) groups.push(root);
  groups.push(...root.querySelectorAll('.suraiya-product-panels'));
  groups.forEach(group => {
    if (group.dataset.accordionReady) return;
    group.dataset.accordionReady = 'true';
    const panels = Array.from(group.children).filter(node => node.matches('details.suraiya-product-panel'));
    let scrollFrame;
    panels.forEach(panel => {
      const summary = panel.querySelector('summary');
      summary.addEventListener('click', event => {
        event.preventDefault();
        cancelAnimationFrame(scrollFrame);
        const shouldOpen = !panel.open;
        panels.forEach(other => { other.open = false; });
        panel.open = shouldOpen;
        if (!shouldOpen) return;
        // Wait for the previous panel to collapse before measuring the heading.
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = requestAnimationFrame(() => {
            if (!panel.open || !panel.isConnected) return;
            const offset = Number(group.dataset.scrollOffset) || 0;
            const top = window.scrollY + summary.getBoundingClientRect().top - offset;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
          });
        });
      });
      panel.addEventListener('toggle', () => {
        if (!panel.open) return;
        panels.forEach(other => {
          if (other !== panel && other.open) other.open = false;
        });
      });
    });
  });
}
initializeSuraiyaPanels(document);
document.addEventListener('shopify:section:load', event => initializeSuraiyaPanels(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('suraiya-saving-price')) {
    customElements.define('suraiya-saving-price', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(
          this.querySelector('[data-variants]').textContent
        );
        this.badge = this.querySelector('[data-discount]');
        this.currentPrice = this.querySelector('[data-current-price]');
        this.originalPrice = this.querySelector('[data-original-price]');
        this.scope = this.closest('.shopify-section') || this.parentElement;
        this.update = () => {
          const form = document.getElementById(this.dataset.form);
          const picker = Array.from(
            this.scope.querySelectorAll('hdt-variant-picker')
          ).find(item => item.getAttribute('form') === this.dataset.form);
          const id = picker?.getAttribute('selected-variant') ||
            form?.querySelector('[name="id"]')?.value;
          if (!id) {
            this.badge.hidden = true;
            return;
          }
          const variant = this.variants.find(
            item => String(item.id) === String(id)
          );
          if (!variant) return;
          if (this.currentPrice.textContent !== variant.priceFormatted) {
            this.currentPrice.textContent = variant.priceFormatted;
          }
          const onSale = variant.compare > variant.price;
          this.originalPrice.hidden = !onSale;
          if (onSale && this.originalPrice.textContent !== variant.compareFormatted) {
            this.originalPrice.textContent = variant.compareFormatted;
          }
          this.badge.hidden =
            this.dataset.showBadge !== 'true' || !onSale;
          if (onSale) {
            const text = 'Save ' + variant.saved;
            if (this.badge.textContent !== text) {
              this.badge.textContent = text;
            }
          }
        };
        this.queue = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(this.update, 100);
        };
        this.onChange = event => {
          if (
            this.scope.contains(event.target) ||
            event.target.form?.id === this.dataset.form
          ) {
            this.queue();
            clearTimeout(this.lateTimer);
            this.lateTimer = setTimeout(this.update, 600);
          }
        };
        document.addEventListener('change', this.onChange);
        this.observer = new MutationObserver(this.queue);
        this.observer.observe(this.scope, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['selected-variant', 'value']
        });
      }
      disconnectedCallback() {
        document.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.lateTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
